// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"guestPage_wrapper__1zOD1","modal":"guestPage_modal__1oO0E","title":"guestPage_title__APuxF","qr":"guestPage_qr__2tdBD","qrTitle":"guestPage_qrTitle__3kOQD"};